import { Card, CardBody } from "reactstrap";
import CountUp from "react-countup";
import {  Spin } from "antd";
import { FormatCurrency } from "../format/formatCurrency";

const CardItem = ({ title, icon, counterEnd, currency, isLoading, isError, error, frozen }) => {
  
  return (
    <Card className="card-animate" style={{ borderRadius: "8px", height: "100%" }}>
      <CardBody>
        <div className="d-flex flex-column align-items-start ">
          <div className="avatar-sm flex-shrink-0 mb-2">
            <img src={icon} alt="Icon" />
          </div>

          <div style={{ color: "#838383", fontFamily: "Poppins" }}>
            {title || "-"}
          </div>

          <div className="d-flex justify-content-start flex-grow-1">
            <h2
              className="text-start mt-0 fs-3 fs-md-2 fs-lg-1"
              style={{ color: "#121212", fontFamily: "Helvetica Neue, sans-serif" }}
            >
              <span className="d-flex align-items-baseline counter-value" style={{ gap: "6px", fontWeight: 700 }}>
                {isLoading ? (
                  <Spin size="small" />
                ) : isError ? (
                  <span style={{ color: "red", fontSize: 16 }}>
                    Erreur, contactez le support
                  </span>
                ) : (
                  <>
                    <CountUp start={0} end={counterEnd || 0} duration={3} formattingFn={(value) => FormatCurrency(value, currency)}/>
                  </>
                )}
              </span>
            </h2>
          </div>
          {frozen ? (
            <div
              title="Montant gelé pour le transfert bancaire"
              style={{
                marginTop: "auto",
                fontSize: "13px",
                color: "#888",
                fontFamily: "Poppins",
              }}
            >
              En cours de transfert :{" "}
              <strong style={{ color: "#888" }}>
                {FormatCurrency(frozen, currency)}
              </strong>
            </div>
          ) : null}
        </div>
      </CardBody>
    </Card>
  );
};

export default CardItem;
